import React, { useState } from "react";
import styles from "../styles/HeaderLoggedIn.module.css";
import { useNavigate } from "react-router-dom";
import DropDownLoggedInHeader from "./DropDownLoggedInHeader";
import MenuModalLoggedIn from "./MenuModalLoggedIn";
import useAuth from "../hooks/useAuth";
import { ROLES } from "../config/roles";
import { USER_ROLE_KEYS } from "../config/userRoles";
import { useGetUsersQuery } from "../features/users/usersApiSlice";
import NotificationBell from "../features/notification/NofiticationBell";
import UnReadNotification from "../features/chat/UnReadNofitication";
import UserImage from "../features/documents/UserImage";
import { useGetCompaniesQuery } from "../features/companies/companyApiSlice";
import LanguageDropdown from "./LanguageDropdown";
import { useTranslation } from "react-i18next";
import { Box, Popover, Skeleton } from "@mui/material";

export default function HeaderLoggedIn() {
  const { t } = useTranslation(["Header"]);
  const navigate = useNavigate();
  const { roles, id, userRole, company: companyId, companyType } = useAuth();
  const isAdmin = roles.some((role) => [ROLES.Admin].includes(role));

  const { user, isLoadingUser, isSuccessUser } = useGetUsersQuery("usersList", {
    selectFromResult: ({ data, isLoading, isSuccess, isError, error }) => ({
      user: data?.entities[id],
      isLoadingUser: isLoading,
      isSuccessUser: isSuccess,
    }),
  });

  const { company, isLoadingCompany } = useGetCompaniesQuery("companiesList", {
    selectFromResult: ({ data, isLoading, isSuccess, isError, error }) => ({
      company: data?.entities[user?.company || companyId],
      isLoadingCompany: isLoading,
    }),
  });

  const [toggleHamburgerMenuModal, setToggleHamburgerMenuModal] =
    useState(false);
  const [anchorElForRegisterTender, setAnchorElForRegisterTender] =
    useState(null);

  const handleClickForRegisterTender = (event) => {
    setAnchorElForRegisterTender(event.currentTarget);
  };

  const handleCloseForRegisterTender = () => {
    setAnchorElForRegisterTender(null);
  };

  const onLogoClick = (event) => {
    event.preventDefault();
    if (companyType === "Institution") {
      navigate("/minar-sidur/profile", { state: { activeTab: "bids" } });
    } else {
      navigate("/minar-sidur");
    }
  };

  const openRegisterTenderPopup = Boolean(anchorElForRegisterTender);
  const idRegisterTenderPopup = openRegisterTenderPopup
    ? "register-tender-popover"
    : undefined;

  return (
    <div className={styles.navBar}>
      <div className={styles.navContent}>
        <div className={styles.logo} onClick={onLogoClick}>
          <a
            href={`${process.env.REACT_APP_FRONTEND_URL}/minar-sidur`}
            rel="noopener noreferrer"
          >
            <img
              src="/bidd_logo.svg"
              alt="bidd-logo"
              className={styles.logoImage}
            />
          </a>
        </div>

        <div className={styles.linksContainer}>
          <div className={styles.navLinks}>
            <LanguageDropdown />
            {isAdmin && (
              <div
                className={`${styles.linkContainer} ${styles.active}`}
                onClick={() => navigate("/minar-sidur/users")}
              >
                {t("users")}
              </div>
            )}
                        {isAdmin && (
              <div
                className={`${styles.linkContainer} ${styles.active}`}
                onClick={() => navigate("/minar-sidur/companies")}
              >
                {t("companies")}
              </div>
            )}
            {isAdmin && (
              <div
                className={`${styles.linkContainer} ${styles.active}`}
                onClick={() => navigate("/minar-sidur/error-dashboard")}
              >
                {t("errorDashboard", "Errors")}
              </div>
            )}
            {isLoadingUser ? (
              <Skeleton
                variant="rectangular"
                width="145px"
                height="40px"
                sx={{ backgroundColor: "rgb(51,51,51)", borderRadius: "6px" }}
              />
            ) : (
              isSuccessUser &&
              user?.isValidated &&
              (USER_ROLE_KEYS.MasterUser === userRole ||
                USER_ROLE_KEYS.SuperUser === userRole) &&
              companyType === "Institution" && (
                <div
                  className={styles.skraBiddButton}
                  onClick={handleClickForRegisterTender}
                >
                  {t("registerTender")}
                </div>
              )
            )}
          </div>

          <UnReadNotification />
          <NotificationBell />

          <div className={styles.profileContainer}>
            <DropDownLoggedInHeader />
          </div>

          <div
            className={`${styles.hamburger} ${
              toggleHamburgerMenuModal === true && styles.selectedHamburger
            }`}
            onClick={() =>
              setToggleHamburgerMenuModal(!toggleHamburgerMenuModal)
            }
          >
            {isLoadingCompany ? (
              <Skeleton
                variant="circular"
                width="45px"
                height="45px"
                sx={{ backgroundColor: "rgb(51,51,51)" }}
              />
            ) : (
              <UserImage
                image={company?.photo_url}
                toggleDropdown={toggleHamburgerMenuModal}
                mobileView={true}
              />
            )}
          </div>
        </div>

        <div className={styles.navLinks2}>
          <LanguageDropdown />
          {isAdmin && (
            <div
              className={`${styles.linkContainer} ${styles.active}`}
              onClick={() => navigate("/minar-sidur/users")}
            >
              {t("users")}
            </div>
          )}
          {isAdmin && (
            <div
              className={`${styles.linkContainer} ${styles.active}`}
              onClick={() => navigate("/minar-sidur/companies")}
            >
              {t("companies")}
            </div>
          )}

          {isLoadingUser ? (
            <Skeleton
              variant="rectangular"
              width="135px"
              height="30px"
              sx={{ backgroundColor: "rgb(51,51,51)", borderRadius: "6px" }}
            />
          ) : (
            isSuccessUser &&
            user?.isValidated &&
            (USER_ROLE_KEYS.MasterUser === userRole ||
              USER_ROLE_KEYS.SuperUser === userRole) &&
            companyType === "Institution" && (
              <div
                className={styles.skraBiddButton}
                onClick={handleClickForRegisterTender}
              >
                {t("registerTender")}
              </div>
            )
          )}
        </div>

        <MenuModalLoggedIn
          toggleModal={toggleHamburgerMenuModal}
          setToggleModal={setToggleHamburgerMenuModal}
        />
      </div>

      <Popover
        id={idRegisterTenderPopup}
        open={openRegisterTenderPopup}
        anchorEl={anchorElForRegisterTender}
        onClose={handleCloseForRegisterTender}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              padding: "10px 16px",
              cursor: "pointer",
              ":hover": { backgroundColor: "#f3f3f3" },
            }}
            onClick={() => navigate("/minar-sidur/new-bid")}
          >
            {t("openTender")}
          </Box>
          <Box
            sx={{
              padding: "10px 16px",
              cursor: "pointer",
              ":hover": { backgroundColor: "#f3f3f3" },
            }}
            onClick={() =>
              navigate("/minar-sidur/new-bid", {
                state: { isCloseTender: true },
              })
            }
          >
            {t("closeTender")}
          </Box>
        </Box>
      </Popover>
    </div>
  );
}
